import { motion } from "framer-motion";

export default function SectionHeader({ overline, title, subtitle, align = "left", testId }) {
  return (
    <div
      data-testid={testId}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          className="font-mono text-xs tracking-[0.25em] uppercase text-[#00F0FF] mb-4 flex items-center gap-3"
        >
          <span className="w-6 h-px bg-[#00F0FF]" />
          {overline}
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-bold leading-[1.05]"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="mt-5 text-base md:text-lg text-[#8B93A5] leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
